import type { Translations } from './en';

export const kn: Translations = {
  'nav.inPlay': 'ಇನ್-ಪ್ಲೇ',
  'nav.aviator': 'Aviator',

  // Bottom navigation bar
  'bottomNav.home': 'ಮುಖಪುಟ',
  'bottomNav.inPlay': 'ಇನ್-ಪ್ಲೇ',
  'bottomNav.offers': 'ಆಫರ್‌ಗಳು',
  'bottomNav.myMarkets': 'ನನ್ನ ಮಾರ್ಕೆಟ್‌ಗಳು',
  'bottomNav.referral': 'ರೆಫರಲ್',
  'bottomNav.passbook': 'ಪಾಸ್‌ಬುಕ್',
  'bottomNav.profile': 'ಪ್ರೊಫೈಲ್',

  'common.deposit': 'ಠೇವಣಿ',
  'common.withdraw': 'ಹಿಂಪಡೆಯಿರಿ',
  'common.rules': 'ನಿಯಮಗಳು',
  'common.all': 'ಎಲ್ಲಾ',
  'common.viewAll': 'ಎಲ್ಲವನ್ನೂ ನೋಡಿ',
  'common.loading': 'ಲೋಡ್ ಆಗುತ್ತಿದೆ...',
  'auth.login': 'ಲಾಗಿನ್',
  'auth.signup': 'ಸೈನ್ ಅಪ್',

  'language.select': 'ಭಾಷೆಯನ್ನು ಆಯ್ಕೆಮಾಡಿ',

  'search.placeholder': 'ಪಂದ್ಯಗಳು / ಕ್ಯಾಸಿನೊ ಆಟಗಳನ್ನು ಹುಡುಕಿ',

  'search.short': 'ಹುಡುಕಿ',
  'search.matches': 'ಪಂದ್ಯಗಳು',
  'search.casinoGames': 'ಕ್ಯಾಸಿನೊ ಆಟಗಳು',
  'search.searching': 'ಹುಡುಕಲಾಗುತ್ತಿದೆ…',
  'search.noResults': '“{term}” ಗೆ ಯಾವುದೇ ಫಲಿತಾಂಶಗಳಿಲ್ಲ',
  'search.hint': 'ತಂಡ, ಲೀಗ್ ಅಥವಾ ಆಟದ ಹೆಸರನ್ನು ಪ್ರಯತ್ನಿಸಿ.',

  'menu.accountStatement': 'ಖಾತೆ ಹೇಳಿಕೆ',
  'menu.betHistory': 'ಬೆಟ್ ಇತಿಹಾಸ',
  'menu.activityLogs': 'ಚಟುವಟಿಕೆ ಲಾಗ್‌ಗಳು',
  'menu.casinoBetHistory': 'ಕ್ಯಾಸಿನೊ ಬೆಟ್ ಇತಿಹಾಸ',
  'menu.bonusStatement': 'ಬೋನಸ್ ಹೇಳಿಕೆ',
  'menu.referral': 'ರೆಫರಲ್',
  'menu.setButtonValues': 'ಬಟನ್ ಮೌಲ್ಯಗಳನ್ನು ಹೊಂದಿಸಿ',
  'menu.changePassword': 'ಪಾಸ್‌ವರ್ಡ್ ಬದಲಾಯಿಸಿ',
  'menu.balance': 'ಬ್ಯಾಲೆನ್ಸ್',
  'menu.exposure': 'ಎಕ್ಸ್‌ಪೋಶರ್',
  'menu.signOut': 'ಸೈನ್ ಔಟ್',

  'sidebar.sports': 'ಕ್ರೀಡೆಗಳು',
  'sidebar.casino': 'ಕ್ಯಾಸಿನೊ',
  'sidebar.soon': 'ಶೀಘ್ರದಲ್ಲೇ',
  'sidebar.noCompetitions': 'ಯಾವುದೇ ಸ್ಪರ್ಧೆಗಳಿಲ್ಲ',
  'sidebar.noMatches': 'ಯಾವುದೇ ಪಂದ್ಯಗಳಿಲ್ಲ',

  'home.casinoProviders': 'ಕ್ಯಾಸಿನೊ ಪೂರೈಕೆದಾರರು',
  'home.live': 'ಲೈವ್',
  'home.virtual': 'ವರ್ಚುವಲ್',
  'home.noLiveMatches': 'ಈಗ ಯಾವುದೇ ಲೈವ್ ಪಂದ್ಯಗಳಿಲ್ಲ',
  'home.noMatches': 'ಯಾವುದೇ ಪಂದ್ಯಗಳು ಲಭ್ಯವಿಲ್ಲ',

  'sport.Cricket': 'ಕ್ರಿಕೆಟ್',
  'sport.Football': 'ಫುಟ್‌ಬಾಲ್',
  'sport.Tennis': 'ಟೆನಿಸ್',
  'sport.Kabaddi': 'ಕಬಡ್ಡಿ',
  'sport.Politics': 'ರಾಜಕೀಯ',
  'sport.Basketball': 'ಬ್ಯಾಸ್ಕೆಟ್‌ಬಾಲ್',
  'sport.Baseball': 'ಬೇಸ್‌ಬಾಲ್',
  'sport.Table Tennis': 'ಟೇಬಲ್ ಟೆನಿಸ್',
  'sport.Volleyball': 'ವಾಲಿಬಾಲ್',
  'sport.Ice Hockey': 'ಐಸ್ ಹಾಕಿ',
  'sport.Rugby': 'ರಗ್ಬಿ',
  'sport.Mixed Martial Arts': 'ಮಿಶ್ರ ಸಮರ ಕಲೆಗಳು',
  'sport.Darts': 'ಡಾರ್ಟ್ಸ್',
  'sport.Futsal': 'ಫುಟ್ಸಲ್',
  'sport.Horse Racing': 'ಕುದುರೆ ರೇಸ್',
  'sport.Greyhound Racing': 'ಗ್ರೇಹೌಂಡ್ ರೇಸಿಂಗ್',

  'market.limits': 'ಕನಿಷ್ಠ: {min} | ಗರಿಷ್ಠ: {max}',
  'market.cashout': 'ಕ್ಯಾಶ್‌ಔಟ್',

  'menu.profile': 'ಪ್ರೊಫೈಲ್',
  'menu.transactionReport': 'ವಹಿವಾಟು ವರದಿ',
  'profile.activeBets': 'ಸಕ್ರಿಯ ಬೆಟ್\u200cಗಳು',
  'profile.joinUs': 'ನಮ್ಮೊಂದಿಗೆ ಸೇರಿ',
  'profile.logout': 'ಲಾಗ್ ಔಟ್',
  'profile.balance': 'ಬ್ಯಾಲೆನ್ಸ್',

  'profile.description': 'ನಿಮ್ಮ ಬ್ಯಾಲೆನ್ಸ್, ವಾಲೆಟ್, ಉಳಿಸಿದ ಖಾತೆಗಳು ಮತ್ತು ವರದಿಗಳು ಒಂದೇ ಕಡೆ.',
  'profile.exposure': 'ಎಕ್ಸ್‌ಪೋಶರ್',
  'profile.bonus': 'ಬೋನಸ್',

  // Deposit popup
  'deposit.availableBalance': 'ಲಭ್ಯವಿರುವ ಬ್ಯಾಲೆನ್ಸ್',
  'deposit.coins': 'ನಾಣ್ಯಗಳನ್ನು ಠೇವಣಿ ಮಾಡಿ',
  'deposit.enterCoins': 'ನಾಣ್ಯಗಳನ್ನು ನಮೂದಿಸಿ',
  'deposit.makePayment': 'ಪಾವತಿ ಮಾಡಿ',
  'deposit.loadingMethods': 'ಪಾವತಿ ವಿಧಾನಗಳು ಲೋಡ್ ಆಗುತ್ತಿವೆ...',
  'deposit.methodsError': 'ಪಾವತಿ ವಿಧಾನಗಳನ್ನು ಲೋಡ್ ಮಾಡಲಾಗಲಿಲ್ಲ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.',
  'deposit.noMethods': 'ಈಗ ಯಾವುದೇ ಪಾವತಿ ವಿಧಾನಗಳು ಲಭ್ಯವಿಲ್ಲ.',
  'deposit.uploadScreenshot': 'ಪಾವತಿ ಸ್ಕ್ರೀನ್‌ಶಾಟ್ ಅಪ್‌ಲೋಡ್ ಮಾಡಲು ಇಲ್ಲಿ ಕ್ಲಿಕ್ ಮಾಡಿ',
  'deposit.optional': '(ಐಚ್ಛಿಕ)',
  'deposit.utrLabel': 'ವಿಶಿಷ್ಟ ವಹಿವಾಟು ಉಲ್ಲೇಖ (UTR)',
  'deposit.utrPlaceholder': '6 ರಿಂದ 23 ಅಂಕಿಗಳ UTR/RRN ಸಂಖ್ಯೆ',
  'deposit.txHash': 'ವಹಿವಾಟು ಹ್ಯಾಶ್',
  'deposit.paste': 'ಅಂಟಿಸಿ',
  'deposit.copy': 'ನಕಲಿಸಿ',
  'deposit.submit': 'ಸಲ್ಲಿಸಿ',
  'deposit.submitting': 'ಸಲ್ಲಿಸಲಾಗುತ್ತಿದೆ...',
  'deposit.scanning': 'ಸ್ಕ್ರೀನ್‌ಶಾಟ್‌ನಿಂದ UTR ಓದಲಾಗುತ್ತಿದೆ...',
  'deposit.scanFound': 'ನಿಮ್ಮ ಸ್ಕ್ರೀನ್‌ಶಾಟ್‌ನಿಂದ UTR ತುಂಬಲಾಗಿದೆ, ಅದು ಸರಿಯಾಗಿದೆಯೇ ಎಂದು ಪರಿಶೀಲಿಸಿ.',
  'deposit.scanNotFound': 'ಸ್ಕ್ರೀನ್‌ಶಾಟ್‌ನಿಂದ UTR ಓದಲಾಗಲಿಲ್ಲ, ದಯವಿಟ್ಟು ಅದನ್ನು ನಮೂದಿಸಿ.',
  'deposit.upiId': 'UPI ಐಡಿ',
  'deposit.name': 'ಹೆಸರು',
  'deposit.walletAddress': 'ವಾಲೆಟ್ ವಿಳಾಸ',
  'deposit.send': 'ಕಳುಹಿಸಿ',
  'deposit.rateUnavailable': 'ಪರಿವರ್ತನೆ ದರ ಲಭ್ಯವಿಲ್ಲ, ದಯವಿಟ್ಟು ನಂತರ ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.',
  'deposit.range': '{min} ರಿಂದ {max} ಕಾಯಿನ್‌ಗಳ ನಡುವೆ ಠೇವಣಿ ಮಾಡಿ',
  'deposit.rangeFrom': 'ಕನಿಷ್ಠ ಠೇವಣಿ {min} ಕಾಯಿನ್‌ಗಳು',
  'deposit.noMethodForAmount': 'ಈ ಮೊತ್ತಕ್ಕೆ ಯಾವುದೇ ಪಾವತಿ ವಿಧಾನವಿಲ್ಲ. ದಯವಿಟ್ಟು ಮೊತ್ತ ಬದಲಿಸಿ.',
  'deposit.displayName': 'ಪ್ರದರ್ಶನ ಹೆಸರು',
  'deposit.upiDetails': 'UPI ವಿವರಗಳು',
  'deposit.bankDetails': 'ಬ್ಯಾಂಕ್ ವಿವರಗಳು',
  'deposit.cryptoDetails': 'ಕ್ರಿಪ್ಟೋ ವಿವರಗಳು',
  'deposit.bankName': 'ಬ್ಯಾಂಕ್ ಹೆಸರು',
  'deposit.accountHolderName': 'ಖಾತೆದಾರರ ಹೆಸರು',
  'deposit.accountNumber': 'ಖಾತೆ ಸಂಖ್ಯೆ',
  'deposit.ifsc': 'IFSC ಕೋಡ್',
  'deposit.amount': 'ಮೊತ್ತ',
  'deposit.hashCode': 'ಹ್ಯಾಶ್ ಕೋಡ್',
  'deposit.enterHash': 'ಹ್ಯಾಶ್ ಕೋಡ್ ನಮೂದಿಸಿ',

  // Withdraw popup
  'withdraw.coins': 'ನಾಣ್ಯಗಳನ್ನು ಹಿಂಪಡೆಯಿರಿ',
  'withdraw.minimum': 'ಕನಿಷ್ಠ ಹಿಂಪಡೆಯುವ ಮೊತ್ತ {min} ನಾಣ್ಯಗಳು',
  'withdraw.overBalance': 'ಮೊತ್ತವು ನಿಮ್ಮ ಲಭ್ಯವಿರುವ ಬ್ಯಾಲೆನ್ಸ್\u200cಗಿಂತ ಹೆಚ್ಚಾಗಿದೆ',
  'withdraw.continue': 'ಮುಂದುವರಿಯಿರಿ',
  'withdraw.loadingAccounts': 'ನಿಮ್ಮ ಖಾತೆಗಳು ಲೋಡ್ ಆಗುತ್ತಿವೆ...',
  'withdraw.accountsError': 'ನಿಮ್ಮ ಖಾತೆಗಳನ್ನು ಲೋಡ್ ಮಾಡಲಾಗಲಿಲ್ಲ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.',
  'withdraw.noAccounts':
    'ಇನ್ನೂ ಉಳಿಸಿದ ಖಾತೆಗಳಿಲ್ಲ. ಹಿಂಪಡೆಯಲು ಬ್ಯಾಂಕ್, UPI ಅಥವಾ ಕ್ರಿಪ್ಟೋ ಖಾತೆಯನ್ನು ಸೇರಿಸಿ.',
  'withdraw.addAccount': 'ಖಾತೆ ಸೇರಿಸಿ',
  'withdraw.bankAccount': 'ಬ್ಯಾಂಕ್ ಖಾತೆ',
  'withdraw.cryptoWallet': 'ಕ್ರಿಪ್ಟೋ ವಾಲೆಟ್',
  'withdraw.accountHolder': 'ಖಾತೆದಾರ',
  'withdraw.accountNumber': 'ಖಾತೆ ಸಂಖ್ಯೆ',
  'withdraw.ifsc': 'IFSC',
  'withdraw.amount': 'ಮೊತ್ತ',
  'withdraw.youReceive': 'ನೀವು ಪಡೆಯುವುದು',
  'withdraw.submit': 'ಹಿಂಪಡೆಯಿರಿ {amount}',
  'withdraw.processing': 'ಪ್ರಕ್ರಿಯೆಗೊಳಿಸಲಾಗುತ್ತಿದೆ...',
};
